<template>
    <div class="modal fade" id="app-modal" tabindex="-1" aria-labelledby="modal-feedLabel" aria-hidden="true"
         data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">


                <slot class="modal-form" />

                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        @click="$emit('close')"></button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Modal',
    emits: ['close'],
    props: {
        backdrop: {
            type: [Boolean, String],
            default: 'static',
        }
    },
}
</script>

<style scoped>

</style>
